import React, { useState, useEffect } from 'react';
import {
  Table,
  UxPerformanceIndicator,
  UxPagination,
  UxTooltip
  //no me estaba andando el tooltip.
} from "botbit-ui-components";
import { getReviewsRankingData } from '../../../api/dashboardV2Api';
import './ReputationTable.css';
import { StarIcon, QuestionMarkBoldIcon, ChartArrowIcon } from './RepTableIcons';
import translate from "../../../config/translations/translate";
import { ReputationChartModal } from '../Modals/localSeoStoreChartModal/reputationChartModal/ReputationChartModal';
import DashboardPeriodSelector from '../dashboardPeriodSelector/DashboardPeriodSelector';
import withEventTracking, { trackers } from '../../../config/withEventTracking';

const ORDER_TYPE_MAP = {
  'reviews': {
    asc: 'TOTAL_REVIEWS_ASC',
    desc: 'TOTAL_REVIEWS_DESC'
  },
  'averageScore': {
    asc: 'AVERAGE_SCORE_ASC',
    desc: 'AVERAGE_SCORE_DESC'
  },
  'oneStar': {
    asc: 'TOTAL_1_STAR_REVIEWS_ASC',
    desc: 'TOTAL_1_STAR_REVIEWS_DESC'
  },
  'twoStars': {
    asc: 'TOTAL_2_STAR_REVIEWS_ASC',
    desc: 'TOTAL_2_STAR_REVIEWS_DESC'
  },
  'threeStars': {
    asc: 'TOTAL_3_STAR_REVIEWS_ASC',
    desc: 'TOTAL_3_STAR_REVIEWS_DESC'
  },
  'fourStars': {
    asc: 'TOTAL_4_STAR_REVIEWS_ASC',
    desc: 'TOTAL_4_STAR_REVIEWS_DESC'
  },
  'fiveStars': {
    asc: 'TOTAL_5_STAR_REVIEWS_ASC',
    desc: 'TOTAL_5_STAR_REVIEWS_DESC'
  },
  'googleMapsScore': {
    asc: 'MAPS_ACUMULATED_SCORE_ASC',
    desc: 'MAPS_ACUMULATED_SCORE_DESC'
  }
};



const ReputationTable = ({ companyId, t, period, timePeriodOptions, selectedPeriod, handlePeriodChange, windowWidth, trackEvent, setSelectedPeriod}) => {
  const [totalPages, setTotalPages] = useState(0);
  const [selectedPage, setSelectedPage] = useState(0);
  const [currentOrder, setCurrentOrder] = useState({ name: 'reviews', direction: 'desc' });
  const filterValues = { timePeriod: selectedPeriod, page: selectedPage, pageSize: 10 }
  const [selectedStore, setSelectedStore] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setSelectedPage(0);
    filterValues.page = 0;
    filterValues.timePeriod = selectedPeriod;
  }, [selectedPeriod, currentOrder])

  const getTableData = async (page, order = currentOrder, filters) => {
    const orderChanged = currentOrder.name !== order.name || currentOrder.direction !== order.direction;
    if(orderChanged) setCurrentOrder(order);
    const mappedOrderType = ORDER_TYPE_MAP[order.name][order.direction];

    try {
      const response = await getReviewsRankingData(
        companyId,
        filters.timePeriod,
        mappedOrderType,
        orderChanged ? 0 : filters.page,
        filters.pageSize
      );

      
      // le agrego el ranking por front.
      if (response && response.data && response.data.data && response.data.data.items) {
        response.data.data.items = response.data.data.items.map((item, index) => ({
          ...item,
          ranking: (filters.page * filters.pageSize) + index + 1
        }));
      }

      //total de paginas.
      const _totalPages = Math.ceil(response.data.data.totalSize / response.data.data.pageSize);
      if(totalPages !== _totalPages) {
        setTotalPages(_totalPages);
      }
      
      return response;
    } catch (error) {
      console.error('Error en getTableData:', error);
      throw error;
    }
  };
  
  //falta el paginador para esta.
  const handlePageChange = (newPage) => {
    // la pagina que me da el paginador, hay que restarle 1 porque la api es 0-based.
    setSelectedPage(newPage - 1);
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleCreateStoreObject = (row) => {
    const store = {
      id: row.storeId,
      name: row.storeName
    };
    setSelectedStore(store);
  };
  const isMediumScreen = windowWidth < 1440;

  const columns = [
    ...(isMediumScreen ? [] : [{dataField: 'ranking',
     title: ' ',
     size: 4,
     formatter: (cellValue, row) => <span className="reputation-table-various-spans-number-bold">#{row.ranking}</span>,
    }]),
    {
      
      //el data field tiene que coincidir con el key de data. 
      //el formatter me re-renderiza cada elemento de la tabla, el cellvalue es el valor y el row es el objeto completo de la fila
      dataField: 'storeName',
      title: <div className="reputation-table-title-container">
        <span 
          className="reputation-table-title-span"
          dangerouslySetInnerHTML={{ __html: t('columns.storeRanking') }} 
        />{/* OJO: aqui viene html en la traduccion, y dangerouslySetInnerHTML> es mas peligroso que el salto de linea */}
      </div>,
      size: 16,
      formatter: (cellValue, row) => {
        const storeName = row.storeName;
        
        return (
            <span className="reputation-table-various-spans-number-bold text-left"> {storeName} </span>
        )
      },
    },
    {
      dataField: 'reviews',
      title: (
        <div className="reputation-table-title-container">
          <span 
            className="reputation-table-title-span"
            dangerouslySetInnerHTML={{ __html: t('columns.generatedReviews') }}
            // OJO: aqui viene html en la traduccion, y dangerouslySetInnerHTML> es mas peligroso que el salto de linea
          /> 
        </div>
      ),
      size: 16,
      sortable: true,
      formatter: (cellValue, row) => (
        <div style={{display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between', maxWidth: '100px'}}>
          <span className="reputation-table-various-spans-number">{row.generatedReviews.value}</span>
          {(row.generatedReviews.variationPercentage !== 0 && row.generatedReviews.variationPercentage !== null) ? (
              <div 
                  title={t('columns.comparisonTooltip')}
                  style={{ cursor: 'pointer' }}
              >
                  <UxPerformanceIndicator value={row.generatedReviews.variationPercentage} />
              </div>
          ) : (
              
              <div 
                  title={t('columns.noDataComparisonTooltip')}
                  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '30px'}}
              >
                  <span className="reputation-table-various-spans-number">-</span>
              </div>
          )}
        </div>
      ),
      tooltip: {
        title: t('columns.generatedReviews.tooltip.title'),
        content: t('columns.generatedReviews.tooltip.content')
      }
      
    },
    {
      dataField: 'fiveStars',
      title: (
        <div className="reputation-table-title-container">
          <StarIcon />
          <span className="reputation-table-title-span">5</span>
        </div>
      ),
      size: 6,
      sortable: true,
      formatter: (cellValue, row) => <span className="reputation-table-various-spans-stars-number">{row.normalizedScoreCount[4]['5']}</span>,
    },
    {
      dataField: 'fourStars',
      title: (
        <div className="reputation-table-title-container">
          <StarIcon />
          <span className="reputation-table-title-span">4</span>
        </div>
      ),
      size: 6,
      formatter: (cellValue, row) => <span className="reputation-table-various-spans-stars-number">{row.normalizedScoreCount[3]['4']}</span>,
      sortable: true,
    },
    {
      dataField: 'threeStars',
      title: (
        <div className="reputation-table-title-container">
          <StarIcon />
          <span className="reputation-table-title-span">3</span>
        </div>
      ),
      size: 6,
      formatter: (cellValue, row) => <span className="reputation-table-various-spans-stars-number">{row.normalizedScoreCount[2]['3']}</span>,
      sortable: true,
    },
    {
      dataField: 'twoStars',
      title: (
        <div className="reputation-table-title-container">
          <StarIcon />
          <span className="reputation-table-title-span">2</span>
        </div>
      ),
      size: 6,
      formatter: (cellValue, row) => <span className="reputation-table-various-spans-stars-number">{row.normalizedScoreCount[1]['2']}</span>,
      sortable: true,
    },
    {
      dataField: 'oneStar',
      title: (
        <div className="reputation-table-title-container">
          <StarIcon />
          <span className="reputation-table-title-span">1</span>
        </div>
      ),
      size: 8,
      formatter: (cellValue, row) => <span className="reputation-table-various-spans-stars-number">{row.normalizedScoreCount[0]['1']}</span>,
      sortable: true,
    },
    {
      dataField: 'averageScore',
      title: <div className="reputation-table-title-container">
        <span 
          className="reputation-table-title-span"
          dangerouslySetInnerHTML={{ __html: t('columns.averageScore') }}
        />
        
      </div>,
      size: isMediumScreen ? 16 : 14,
      sortable: true,
      formatter: (cellValue, row) => <span className="reputation-table-various-spans-number-bold-bigger">
        {Number(row.scoreAverageInThePeriod).toFixed(1)}
      </span>,
      tooltip: {
        title: t('columns.averageScore.tooltip.title'),
        content: t('columns.averageScore.tooltip.content')
      }
    },
    {
      dataField: 'googleMapsScore',
      title: <div className="reputation-table-title-container">
        <span 
          className="reputation-table-title-span"
          dangerouslySetInnerHTML={{ __html: t('columns.googleMaps') }}
        />
       
      </div>,
      size: isMediumScreen ? 16 : 14,
      sortable: true,
      formatter: (cellValue, row) => <span className="reputation-table-various-spans-number-rating-maps">{row.scoreAverageShowedByGoogleMaps}</span>,
      tooltip: {
        title: t('columns.googleMaps.tooltip.title'),
        content: t('columns.googleMaps.tooltip.content')
      }
    },
    {
      dataField: 'details',
      title: '',
      size: 4,
      formatter: (cellValue, row) => {
        const handleRedirect = () => {
          handleCreateStoreObject(row);
          setIsModalOpen(true);
          trackEvent('Dashboard_reputacion_ver_detalle_clicked', {
            storeId: row.storeId,
            companyId: companyId,
            period: selectedPeriod,
          }, false, [trackers.MIXPANEL]);
        };
        
        return (
          <button className="reputation-table-details-button" onClick={handleRedirect}>
            <ChartArrowIcon />
          </button>
        );
      },
    }

  ];

  return (
    <div className="reputation-table-container">
      <div className="reputation-table-header-container">
        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
          <h2 className="reputation-table-title">{t('title')}</h2>
          <div className="reputation-table-title-tooltip-container">
            <QuestionMarkBoldIcon/>
            <UxTooltip title="Tooltip incorporado a la Table" content="Tooltip incorporado a la Table" />
          </div>
        </div>
        <DashboardPeriodSelector 
          timePeriodOptions={timePeriodOptions}
          t={t}
          selectedPeriod={selectedPeriod}
          handlePeriodChange={handlePeriodChange}
          setSelectedPeriod={setSelectedPeriod}
        />
      </div>

      <div className="reputation-table-body-and-pagination-container">
          <Table
            pagination={false}
            getData={getTableData}
            filterValues={filterValues}
            columns={columns}
            showMobileColumnTitles={true}
            dataPath={"data.data.items"}
            elementKey={"storeId"}
          />
        <div className="pagination-container">
        {totalPages > 1 && (
          <UxPagination
              totalPages={totalPages}
              // las paginas de la api son 0-based, por eso le sumo 1. (el paginador es 1-based)
            currentPage={filterValues.page + 1}
                onPageChange={handlePageChange}
              />
            )}
        </div>
      </div>
      <div className="reputation-table-modal-container">
        {selectedStore && (
          <ReputationChartModal
            store={selectedStore}
            isOpen={isModalOpen}
            toggle={toggleModal}
            selectedPeriod={period}
            t={t}
          />
        )}
      </div>
    </div>
  );
};

ReputationTable.translations = {
  title: {
    es: "Ranking sucursales por review",
    en: "Store ranking by review"
  },
  timePeriod: {
    label: {
      es: "Período de tiempo",
      en: "Time period"
    },
    options: {
      LAST_7_DAYS: {
        es: "Últimos 7 días",
        en: "Last 7 days"
      },
      LAST_30_DAYS: {
        es: "Últimos 30 días",
        en: "Last 30 days" 
      },
      PAST_MONTH: {
        es: "Mes pasado",
        en: "Past Month"
      },
      THIS_MONTH: {
        es: "Este mes",
        en: "This month"
      },
      LAST_3_MONTHS: {
        es: "Últimos 3 meses",
        en: "Last 3 months"
      },
      LAST_6_MONTHS: {
        es: "Últimos 6 meses",
        en: "Last 6 months"
      },
      LAST_12_MONTHS: {
        es: "Últimos 12 meses", 
        en: "Last 12 months"
      },
      THIS_YEAR: {
        es: "Este año",
        en: "This year"
      },
      CUSTOM: {
        es: "Personalizado",
        en: "Custom"
      }
    }
  },
  columns: {
    storeRanking: {
      es: "Ranking<br/>Sucursales",
      en: "Store<br/>Ranking"
    },
    generatedReviews: {
      es: "Reviews<br/>Generados",
      en: "Generated<br/>Reviews",
      tooltip: {
        title: {
          es: "Reviews generados",
          en: "Generated reviews"
        },
        content: {
          es: "Reviews generados en el periodo seleccionado",
          en: "Reviews generated in the selected period"
        }
      }
    },
    averageScore: {
      es: "Score Promedio<br/>Periodo",
      en: "Average Score<br/>Period",
      tooltip: {
        title: {
          es: "Score promedio periodo",
          en: "Average period score"
        },
        content: {
          es: "Score promedio de reviews generados en el periodo seleccionado",
          en: "Average score of reviews generated in the selected period"
        }
      }
    },
    googleMaps: {
      es: "Score actual en<br/>Google Maps",
      en: "Current score in<br/>Google Maps",
      tooltip: {
        title: {
          es: "Score actual en Google Maps",
          en: "Current score in Google Maps"
        },
        content: {
          es: "Score actual de Reviews que muestra Google Maps",
          en: "Current score of reviews shown on Google Maps"
        }
      }
    },
    comparisonTooltip: {
      es: "Esta comparación muestra el porcentaje de cambio entre el período y el mismo período del año anterior. Ejemplo: El mes pasado compara abril 2025 con abril 2024. Si no hay suficientes datos para el período anterior, esta comparación se ocultará.",
      en: "This comparison shows the percent of change between the period and the same period the year before. Example: Last month compares April 2025 with April 2024. If there is not enough data for the previous period, this comparison will be hidden."
    },
    noDataComparisonTooltip: {
      es: "Esta comparación no aplica, ya sea porque no hay datos suficientes o porque el periodo a comparar en esta métrica suma 0.",
      en: "This comparison does not apply, either because there is not enough data or because the previous period sum of values equals 0."
    }

  }
};

export default withEventTracking(translate(ReputationTable));